module.exports = __webpack_public_path__ + "img/front_page_policies.8836ad4b.svg";